import { notification } from "antd";
import { useStoreActions, useStoreState } from "easy-peasy";
import React, { useEffect } from "react";

export default function ErrorHandler() {
  const state = useStoreState((store) => store.error);
  const { setMessage } = useStoreActions((store) => store.error);

  useEffect(() => {
    if (state.message) {
      notification.error({
        message: "Hata",
        description: state.message,
      });

      setMessage("");
    }
  }, [state.message]);

  return <></>;
}
